import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

// Hide the CTA on auth, dashboard, and admin pages where it doesn't make sense.
// Also skip on `/` — the new one-page-two-doors homepage renders its own
// final CTA band inline so we don't stack two nearly-identical calls to action.
const HIDDEN_PREFIXES = ["/admin", "/login", "/signup", "/dashboard", "/employer/dashboard", "/professional/dashboard", "/inbox", "/notifications", "/settings"];

export const PreFooterCTA = () => {
    const { pathname } = useLocation();
    if (pathname === "/") return null;
    if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) return null;

    return (
        <section data-testid="pre-footer-cta" className="bg-background border-t border-border">
            <div className="container-page py-20 sm:py-24">
                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-navy via-brand-navy to-slate-900 dark:from-slate-900 dark:via-slate-900 dark:to-black p-10 sm:p-14 text-center">
                    <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-brand-green/20 blur-3xl pointer-events-none" />
                    <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-emerald-500/10 blur-3xl pointer-events-none" />
                    <div className="relative">
                        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">
                            <Sparkles size={12} className="text-brand-green" /> AI-powered talent platform
                        </div>
                        <h2 className="mt-5 font-heading font-medium text-4xl sm:text-5xl tracking-tight text-white max-w-3xl mx-auto">
                            Ready to Experience Smarter Hiring?
                        </h2>
                        <p className="mt-4 text-white/70 text-lg max-w-2xl mx-auto leading-relaxed">
                            Whether you're looking for your next opportunity or your next great hire, Simonara AI helps you move faster with verified Talent Passports and intelligent matching.
                        </p>
                        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                            <Link to="/employers" data-testid="pre-footer-cta-find-talent" className="btn-green">
                                Find Talent <ArrowRight size={15} className="ml-2" />
                            </Link>
                            <Link to="/talent" data-testid="pre-footer-cta-build-passport" className="btn-pill border border-white/25 text-white hover:bg-white hover:text-brand-navy">
                                Build Your Talent Passport
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PreFooterCTA;
